import { render, staticRenderFns } from "./AdsterraBanner.vue?vue&type=template&id=35f40b85&scoped=true"
import script from "./AdsterraBanner.vue?vue&type=script&lang=js"
export * from "./AdsterraBanner.vue?vue&type=script&lang=js"
import style0 from "./AdsterraBanner.vue?vue&type=style&index=0&id=35f40b85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f40b85",
  null
  
)

export default component.exports